// extracted by mini-css-extract-plugin
export var avatarContainer = "_4y-1";
export var largeAvatarContainer = "_4y-2";
export var smallAvatarContainer = "_4y-0";